module.exports = __webpack_public_path__ + "assets/images/Upload-Data.svg";